import styles from './Preview.module.scss';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';
import { useRouter } from 'next/router';
import { useDictionaryContext } from 'application/contexts/DictionaryContext';

export interface PreviewProps {
	url: string;
	children?: React.ReactNode;
}

export const Preview: React.FC<PreviewProps> = ({ children, url }) => {
	const { isPreview } = useRouter();
	const dictionary = useDictionaryContext();
	const inPreviewText = dictionary.getValue('Preview.InPreview');
	const exitPreviewText = dictionary.getValue('Preview.ExitPreview');

	if (!isPreview) return <>{children}</>;

	return (
		<div className={styles.Preview}>
			<div className={styles.Preview_top}>
				<p>
					{inPreviewText != 'Preview.InPreview' ? inPreviewText : 'Du er i øjeblikket i preview mode'}
					{' - '}
					<UI_Link className={styles.Preview_link} href={`/api/exitPreview?slug=${url}`}>
						{exitPreviewText != 'Preview.ExitPreview' ? exitPreviewText : 'Afslut preview'}
					</UI_Link>
				</p>
			</div>
			<div className={styles.Preview_content}>{children}</div>
		</div>
	);
};
